import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { usePageMeta } from "@/lib/seo";
import { useLocalePath } from "@/lib/locale";

/* 404 real (Fase 13 — WS5): noindex + navegación útil, nunca pantalla vacía.
 * Nota técnica: como SPA el status HTTP es 200; el noindex evita indexación
 * de rutas inexistentes y la página ofrece salidas reales al usuario. */
export default function NotFound() {
  const { t } = useTranslation();
  const lp = useLocalePath();
  usePageMeta({
    title: t("nf.title") + " | AOS Equestrian",
    description: t("nf.desc"),
    robots: "noindex, follow",
  });
  return (
    <main className="min-h-[60vh] flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="max-w-lg text-center py-24">
        <p className="text-xs uppercase tracking-[0.2em] text-black/40 mb-4">404</p>
        <h1 className="text-3xl sm:text-4xl font-semibold text-[#0A0A0A] mb-4">{t("nf.title")}</h1>
        <p className="text-base text-black/60 mb-8">{t("nf.desc")}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to={lp("/")} data-testid="not-found-home-link"
                className="inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] text-white px-5 h-11 text-sm font-medium hover:bg-black/85 transition-colors">
            {t("nf.home")}
            <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </Link>
          <Link to="/auctions" data-testid="not-found-auctions-link"
                className="inline-flex items-center rounded-full border border-black/10 px-5 h-11 text-sm font-medium text-[#0A0A0A] hover:bg-black/5 transition-colors">
            {t("nf.auctions")}
          </Link>
        </div>
      </div>
    </main>
  );
}
